var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 2.25a2.25 2.25 0 00-2.25 2.25l1.5 1.5V4.5a.75.75 0 011.5 0v3l1.5 1.5V4.5A2.25 2.25 0 0017 2.25zm0 20.5A2.75 2.75 0 0019.75 20v-8.379l1.973 1.973a.75.75 0 001.06-1.06L12.53 2.28a.75.75 0 00-1.06 0L1.217 12.533a.75.75 0 101.06 1.061l1.973-1.973V20A2.75 2.75 0 007 22.75h10zM11.5 12.5a2.75 2.75 0 00-2.75 2.75v6H7c-.69 0-1.25-.56-1.25-1.25v-9.879L12 3.871l6.25 6.25V20c0 .69-.56 1.25-1.25 1.25h-1.75v-6a2.75 2.75 0 00-2.75-2.75h-1zm2.25 8.75v-6c0-.69-.56-1.25-1.25-1.25h-1c-.69 0-1.25.56-1.25 1.25v6h3.5z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.6a45aa1db8f0ee204e21a81c2ee92e6b.svg";
export { ForwardRef as ReactComponent };